import React, { Component } from 'react';
import { Button, Col, Form, Modal } from 'react-bootstrap';

import './CategoryChange.css';

class MusterPointChange extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            categoryRecordings: [],
            categoryTitle: 'Category',
            errMsg: ''
        };
    }

    onLoad = () => {
        fetch('category_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0" //all categories
        })
        .then(res => res.json())
        .then((data) => {
            this.setState({ categories: data });
        })
        .catch(console.log)

        this.loadMusterRecordings();

        fetch('get_category_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && data[0].value) {
                this.setState({ categoryTitle: data[0].value });
            }
        })
        .catch(console.log)
    }

    //baseline choices are the recordings assigned to this muster point
    loadMusterRecordings = () => {

        fetch('muster_point_recordings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "musterPointId=" + this.props.category.musterPointId
        })
        .then(res => res.json())
        .then((data) => {
            this.setState({ categoryRecordings: data });
        })
        .catch(console.log)
    }

    renderCategoryData = () => {

        return this.state.categories.map((category) => (
            <option value={category.categoryId}>{category.title}</option>
        ))
    }

    renderBaselineRecordingData = () => {

        return this.state.categoryRecordings.map((recordings) => (
            <option value={recordings.filename}>{recordings.filename}</option>
        ))
    }

    //colours are stored as 6 hex digits without '#' (see the muster point list swatch rendering);
    //the native picker works in '#rrggbb', so convert in both directions
    handlePickColour = (e) => {
        this.props.handleUpdateColourChange({ target: { value: e.target.value.replace('#', '') } });
    }

    pickerColour = () => {
        const colour = this.props.category.colour;
        return /^[0-9a-fA-F]{6}$/.test(colour) ? '#' + colour : '#000000';
    }

    handleUpdateCategory = (e) => {
        e.preventDefault();
        e.stopPropagation();

        fetch('muster_point_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "musterPointId=" + this.props.category.musterPointId +
                  "&title=" + this.props.category.title +
                  "&colour=" + this.props.category.colour +
                  "&baselineRecording=" + (this.props.category.baselineRecording || '') +
                  "&x=" + (this.props.category.x || '0.0') +
                  "&y=" + (this.props.category.y || '0.0') +
                  "&z=" + (this.props.category.z || '0.0') +
                  "&azimuth=" + (this.props.category.azimuth || '0.0') +
                  "&categoryId=" + (this.props.category.categoryId || '1')
        })
        .then(res => res.json())
        .then(data => {
            if ('true' === data[0].update) {
                this.setState({ errMsg: '' });
                this.props.hideUpdateCategory();
            }
            else {
                this.setState({ errMsg: data[0].msg });
            }
        })
        .catch(console.log)
    }

    render() {
        return (

            <Modal
              show={this.props.updateCategoryVisible}
              onHide={this.props.hideUpdateCategory}
              onEntered={this.onLoad}
              backdrop="static"
              centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Update {this.props.musterTitle || 'Muster Point'}</h1></center></Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                <Form className="ProcessAddForm" onSubmit={this.handleSubmit}>
                    <Form.Row>
                        <Form.Group as={Col} controlId="frmTitle">
                            <Form.Label class="CategoryAddLabel">Title</Form.Label>
                            <Form.Control className="CategoryAddControl" type="text" placeholder="title" value={this.props.category.title} onChange={this.props.handleUpdateTitleChange}/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="frmColour">
                            <Form.Label class="CategoryAddLabel">Colour</Form.Label>
                            <div style={{ display: 'flex' }}>
                                <Form.Control className="CategoryAddControl" type="text" placeholder="colour" value={this.props.category.colour} onChange={this.props.handleUpdateColourChange}/>
                                <input
                                    type="color"
                                    title="Pick a colour"
                                    value={this.pickerColour()}
                                    onChange={this.handlePickColour}
                                    style={{ width: '3rem', marginLeft: '0.5rem', padding: '0', border: '1px solid #282c34', borderRadius: '0.25rem', cursor: 'pointer', alignSelf: 'stretch' }}
                                />
                            </div>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="frmX">
                            <Form.Label class="CategoryAddLabel">X</Form.Label>
                            <Form.Control className="CategoryAddControl" type="number" step="any" value={this.props.category.x || '0.0'} onChange={this.props.handleUpdateXChange}/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="frmY">
                            <Form.Label class="CategoryAddLabel">Y</Form.Label>
                            <Form.Control className="CategoryAddControl" type="number" step="any" value={this.props.category.y || '0.0'} onChange={this.props.handleUpdateYChange}/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="frmZ">
                            <Form.Label class="CategoryAddLabel">Z</Form.Label>
                            <Form.Control className="CategoryAddControl" type="number" step="any" value={this.props.category.z || '0.0'} onChange={this.props.handleUpdateZChange}/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="frmAzimuth">
                            <Form.Label class="CategoryAddLabel">Azimuth</Form.Label>
                            <Form.Control className="CategoryAddControl" type="number" step="any" value={this.props.category.azimuth || '0.0'} onChange={this.props.handleUpdateAzimuthChange}/>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Label class="CategoryAddLabel">Baseline Recording</Form.Label>
                        <Form.Control as="select" size="sm" value={this.props.category.baselineRecording || ''} onChange={this.props.handleUpdateBaselineRecordingChange}>
                            <option value="">(none)</option>
                            { this.renderBaselineRecordingData() }
                        </Form.Control>
                    </Form.Row>

                    <Form.Row>
                        <Form.Label class="CategoryAddLabel">{this.state.categoryTitle}</Form.Label>
                        <Form.Control as="select" size="sm" value={this.props.category.categoryId} onChange={this.props.handleUpdateCategoryIdChange}>
                            { this.renderCategoryData() }
                        </Form.Control>
                    </Form.Row>

                </Form>
            </div>
            </Modal.Body>

            <Modal.Footer>
                <span className="userAddErr">{this.state.errMsg}</span>
                <Button onClick={this.handleUpdateCategory}>Update</Button>
                <Button onClick={this.props.hideUpdateCategory}>Close</Button>
            </Modal.Footer>
            </Modal>
        )
    }
}

export default MusterPointChange;
